<template>
    <div class="cz2__modal-popup cz2__modal-popup--leaving">
        <div class="cz2__modal-popup__body">
            <focus-lock>
                <div class="cz2__modal-popup__content" tabindex="0">
                    <button class="cz2__modal-popup__close" :aria-lable="$t('POPUP_CLOSE')" @click.prevent="close">
                    </button>

                    <div class="cz2__modal-popup__header cz2__type__header">
                        {{$t('POPUP_LEAVING_HEADER')}}
                    </div>

                    <div class="cz2__modal-popup__body-copy cz2__type__small">
                        {{$t('POPUP_LEAVING_BODY')}}
                    </div>

                    <button class="cz2__modal-popup__button-ok" @click.prevent="confirm">
                        {{$t('POPUP_LEAVING_OK')}}
                    </button>

                    <div class="cz2__leaving-save">
                        <button class="cz2__leaving-save__button" @click.prevent="confirmSave">
                            <span class="cz2__leaving-save__button-icon">
                            </span>

                            <span class="cz2__leaving-save__button-text cz2__type__small">
                                {{$t('POPUP_LEAVING_SAVE')}}
                            </span>
                        </button>
                    </div>
                </div>
            </focus-lock>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__leaving-save {
            margin-top: 30px;
        }

        .cz2__leaving-save__button {
            text-align: center;
        }

        .cz2__leaving-save__button-icon {
            display: block;

            width: $icon-size;
            height: $icon-size;

            margin: 0 auto 10px;

            background: transparent url(../assets/heart@2x.png) no-repeat center/contain;
        }

        .cz2__leaving-save__button-text {
            display: block;

            white-space: nowrap;
        }
    }
</style>

<script>
    import FocusLock from 'vue-focus-lock';

    export default {
        components: {
            FocusLock,
        },

        methods: {
            close() {
                this.$store.dispatch('showExitConfirmation', false);
            },

            cancel() {
                this.$store.dispatch('showExitConfirmation', false);
            },

            confirm() {
                this.$store.dispatch('globalCancel');
                this.$store.dispatch('showExitConfirmation', false);
            },

            confirmSave() {
                this.$store.dispatch('saveWishlist', {
                    cancelAfter: true,
                });
            },
        },
    };
</script>
